import { removeNews } from "../../../store/knowledgeBase/slice"
import { newslineApi } from "./newsline"

export const removeNewslineItem = (articleCode: string) => {
    return removeNews(articleCode)
}

export const fetchNewsline = (projectId: string) => {
    return newslineApi.endpoints.getNewsline.initiate(projectId, {
        forceRefetch: true
    })
}
